
export const VAR_LOCALSTORAGE_LANGUAGE = 'gd6d_language'

export const VAR_LOCALSTORAGE_TOKEN = 'gd6d_app_token'

export const VAR_LOCALSTORAGE_LOADING = 'gd6d_app_loading'

export const VAR_LOCALSTORAGE_DARKMODE = 'gd6d_dark_mode'
